module.exports = __webpack_public_path__ + "static/img/id-f.77a73ed2.png";